import {
  AcademicCapIcon,
  BuildingLibraryIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';

import { routes } from './routes';

export const IPLAN_DESCRIPTION =
  'IPlan is an integrated planning tool that helps teachers create comprehensive and cohesive lesson plans. It combines various planning elements into one streamlined workflow.';

export const IPLAN_TITLE = 'IPlan';

export const REGION7_TITLE = 'Ongoing collaboration with DepEd Region 7';

export const REGION7_DESCRIPTION =
  "We've partnered with Region 7 to create customized lesson planning tools that address specific curriculum needs. Our collaboration has resulted in specialized resources, professional development opportunities, and streamlined planning processes to support educators throughout the region.";

export const WELCOME_TITLE = 'Welcome to IPlan';

export const WELCOME_DESCRIPTION =
  'IPlan is your all-in-one integrated lesson planning platform. Navigate to the specific tools in the IPlan menu to create comprehensive lesson plans tailored for Region 7 educators.';

export const TOOLS = [
  {
    title: 'Learning Competency',
    description:
      'Unpack standards and objectives to create comprehensive learning materials',
    gradient: 'from-blue-500 to-cyan-400',
    path: routes.GENERIC_UNPACKING,
  },
  {
    title: 'IPlan Objectives',
    description:
      'Define clear learning outcomes aligned with curriculum standards',
    gradient: 'from-purple-500 to-pink-400',
    path: routes.IPLAN_OBJECTIVE,
  },
  {
    title: 'Lesson Plan',
    description: 'Create detailed lesson plans with activities and assessments',
    gradient: 'from-orange-500 to-amber-400',
    path: routes.MAIN,
  },
];

export const GET_STARTED_STEPS = [
  'Select the tool that fits your current planning needs',
  'Enter your specific requirements and standards',
  'Generate your customized content',
  'Review, edit, and export your materials',
];

export const REGION_STATISTICS = [
  {
    icon: BuildingLibraryIcon,
    value: '7',
    label: 'School Divisions',
    bgColor: 'bg-blue-100',
    iconColor: 'text-blue-600',
    textColor: 'text-blue-800',
    valueColor: 'text-blue-600',
  },
  {
    icon: AcademicCapIcon,
    value: '100+',
    label: 'Schools',
    bgColor: 'bg-indigo-100',
    iconColor: 'text-indigo-600',
    textColor: 'text-indigo-800',
    valueColor: 'text-indigo-600',
  },
  {
    icon: UserGroupIcon,
    value: '5,000+',
    label: 'Teachers',
    bgColor: 'bg-purple-100',
    iconColor: 'text-purple-600',
    textColor: 'text-purple-800',
    valueColor: 'text-purple-600',
  },
] as const;

export const IPLAN_FILIPINO_SECTIONS = [
  'I. Panimulang Gawain (pumili lamang ng isa):',
  'II. Gawain (pumili lamang ng isa):',
  'III. Pagsusuri:',
  'IV. Pagtatalakay:',
  'V. Paglalapat:',
];
